<template>
    <jet-modal ref="modal"
        :show="show_modal"
        maxWidth="2xl"
        @close="show_modal = false">

        <div v-if="modal_type == 'appearance'"
            class="overflow-y-auto p-8">
            <appearance-detail :w_settings="widget_settings" :is_modal="true" />
        </div>
        <div v-else-if="modal_type == 'installation'"
            class="overflow-y-auto p-8">
            <installation-detail :snippet_original="snippet_original" :is_modal="true" />
        </div>
        <div v-else-if="modal_type == 'launcher'"
            class="overflow-y-auto p-8">
            <launcher-detail :w_settings="widget_settings" :is_modal="true" />
        </div>
        <div v-else-if="modal_type == 'integrations'"
            class="overflow-y-auto p-8">
            <integrations-detail :integrations="integrations" :is_modal="true" />
        </div>
        <div v-else-if="modal_type == 'snippet'"
            class="overflow-y-auto p-8">
            <snippet-detail :blur_snippet="blur_snippet"
            :is_modal="true" />
        </div>

    </jet-modal>
</template>

<script>

import JetModal from '@/Jetstream/Modal'
import AppearanceDetail from '@/Components/Settings/AppearanceDetail'
import InstallationDetail from '@/Components/Settings/InstallationDetail'
import LauncherDetail from '@/Components/Settings/LauncherDetail'
import IntegrationsDetail from '@/Components/Settings/IntegrationsDetail'
import SnippetDetail from '@/Components/Settings/SnippetDetail'

export default {

    props: ['modal_type','widget_settings',"snippet_original", "integrations", "blur_snippet"],

    components: {
        JetModal, AppearanceDetail, InstallationDetail,
        LauncherDetail, IntegrationsDetail, SnippetDetail,
        // JetButton, JetSecondaryButton
    },

    data() {
        return {
            show_modal: false
        }
    },
    mounted: function() {

        //console.log(this.integrations);
    },
    methods: {
        open: function() {
           this.show_modal = true
        },
        close: function() {
            this.show_modal = false
        }
    }
}

</script>

